<template>
  <div>
    <Head title="Dashboard" />
    <h1 class="mb-6 text-3xl font-bold">Dashboard</h1>
    <p class="mb-8 leading-normal">Tarmac helps General Contractors and Framers deliver.</p>
  </div>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'

export default {
  components: {
    Head,
  },
  layout: Layout,
}
</script>
